import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { fetchUsers, fetchUsersImage, resetUserImageUpload, uploadUsersImage } from "../redux/slices/userSlice";
import ClipLoader from "react-spinners/ClipLoader";

const SettingRap = styled.div`
  background: #ffffff;
  border: 1px solid #bac0d499;
  border-radius: 20px;
  padding: 40px;
  @media (max-width: 992px) {
    padding: 10px;
  }
   .schedule-btn {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-style: solid;
    width: 430px !important;
    height: 50px !important;
    border-radius: 100px;
    padding: 12px;
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    border-color: #060b13;
  }
  .link-container {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
  }
  .link {
    text-decoration: none;
    color: #818893;
    font-size: 14px;
    font-weight: 500;
    padding-bottom: 10px;
  }
  .link.active {
    color: #060b13;
    border-bottom: 3px solid #000000;
  }
  .profile-link-contain {
    border: 1px solid #bac0d4b2;
    width: fit-content;
    height: 42px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 3px;
    margin-bottom: 20px;
    justify-content: space-between;
  }
  .profile-link {
    text-decoration: none;
    color: #818893;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 110px;
    height: 34px;
  }
  .profile-link.active {
    background: #10182814;
    color: #060b13;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 110px;
    height: 34px;
    border-radius: 5px;
  }
  .user-info-1 p {
    text-align: center;
    color: #828286;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    max-width: 240px;
  }
  .user-info-1 img {
    width: 83px;
    height: 83px;
    border-radius: 50%;
    margin-bottom: 10px;
  }
  .user-info-1 {
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
  }
  .user-info-2 p {
    width: 348px;
    height: 48px;
    border-radius: 100px;
    border: 0.8px solid #bac0d4b2;
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 400;
    color: #060b13;
    font-size: 14px;
    padding: 15px;
  }
  .user-info-2 {
    display: flex;
    gap: 20px;
  }
  .user-info-btn button {
    border-top: 1px;
    border-left: 1px;
    border-right: 4px;
    border-bottom: 4px;
    width: 209px;
    border-style: solid;
    height: 44px;
    border-radius: 100px;
    border-color: #060b13;
  }
  .user-info-btn {
    display: flex;
    gap: 20px;
    align-items: center;
  }
  .profile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .channel {
    align-items: flex-start;
  }
  .channel-1 {
    margin: auto;
  }

  .all-account {
    border: 1px solid #eaecf0;
    border-radius: 12px;
    padding: 15px;
    margin-right: 70px;
  }
  .setting-div-2 {
    border: 0.7px solid #bac0d499;
    padding: 16px 32px;
    padding-bottom: 48px;
    border-radius: 20px;
  }
  .setting-div-1 h4 {
    color: #060b13;
    font-size: 20px;
    font-weight: 600;
  }
  .setting-div-1 p {
    color: #363d4f;
    font-weight: 400;
    font-size: 15px;
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .password-div {
    width: 387px;
    position: relative;
  }
  .pass-lock {
    position: absolute;
    left: 15px;
    top: 15px;
  }
  .pass-eye {
    position: absolute;
    top: 15px;
    right: 15px;
  }
  .password-div input {
    border: 0.7px solid #bac0d4b2;
    width: 387px;
    height: 48px;
    padding-left: 40px;
    border-radius: 100px;
  }
  .all-password {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .sub-notify label {
    color: #060b13;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 14px;
  }
  .sub-notify input {
    border: 1.25px solid #ffffff;
    border-radius: 2px;
    width: 20;
    height: 20px;
  }
  .sub-notify p {
    color: #99a2af;
    margin: 0px;
    font-weight: 400;
    line-height: 18px;
    margin-left: 20px;
    font-size: 14px;
    margin-top: 8px;
  }
  .notice {
    max-width: 268px;
  }
  .monthly-sub {
    border: 0.8px solid #bac0d4b2;
    width: 387px;
    height: 50px;
    border-radius: 100px;
    padding: 0px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .down-notice {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .down-notice p {
    color: #363d4f;
    font-size: 14px;
    font-weight: 400;
  }
  .notifications {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .custom-radio {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #060b13;
  }

  .custom-radio input[type="radio"] {
    display: none; /* Hide default radio button */
  }

  .radio-checkmark {
    height: 20px;
    width: 20px;
    border: 2px solid red;
    border-radius: 50%;
    margin-right: 10px;

    position: relative;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark {
    background-color: transparent;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark:before {
    content: "";
    position: absolute;
    top: 3px;
    left: 3px;
    height: 10px;
    width: 10px;
    background-color: red;
    border-radius: 50%;
  }
  .upload-img-div {
    display: inline-block;
    padding: 8px 16px;
    background: #e8e9eb;

    color: #060b13 !important;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
  }
  .fileInput {
    display: none;
  }
  .tap-to-upload h6 {
    font-size: 14px;
    color: #171717;
    font-weight: 500;
  }
  .file-upload {
    width: 201px;
    height: 83px;

    justify-content: center;
    display: flex;
    gap: 16px;
    border-radius: 15px;
    align-items: center;
    border: 0.8px solid #bac0d4b2;
  }
  .tap-to-upload p {
    font-size: 12px;
    color: #9499ac;
    font-family: "Inter";
  }
  .uploadedImage {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .uploadedImage p {
    font-weight: 400;
    max-width: 201px;
    font-size: 12px;
    color: #828286;
  }
  .uploadedImage-default {
    max-width: 201px;
    height: 83px;
    border-radius: 5px;
  }
  .add-uploaded-divs {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .linkdropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    width: 387px;
    border-radius: 10px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    border-radius: 10px;
    position: absolute;
  }
  .linkdropdown h6 {
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
    padding: 5px !important;
    margin: 0px;

    border-radius: 6px;
  }
  .linkdropdown h6:hover {
    background: #e8e9eb;
  }
  .premium h4 {
    color: #060b13;
    font-weight: 500;
    font-size: 18px;
  }
  .premium h5 {
    color: #060b13;
    font-size: 12px;
    font-weight: 500;
    background: #ecedee;
    padding: 2px 10px;
    border-radius: 16px;
  }
  .premium {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .premium-plan p {
    color: #818893;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    margin-top: 10px;
  }
  .per-month h3 {
    color: #060b13;
    font-size: 48px;
    font-weight: 600;
  }
  .per-month p {
    color: #818893;
    font-size: 16px;
    font-weight: 500;
  }
  .per-month {
    display: flex;
    align-items: flex-end;
  }
  .all-plan-premium {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px;
  }
  .dated {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .dated p {
    color: #818893;
    font-size: 14px;
    font-weight: 400;
  }
  .dated-divs {
    border: 0.7px solid #bac0d499;
    padding: 16px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 15px;
  }
  .upgrade {
    border-top: 0.7px solid #bac0d499;
    padding: 15px;
    display: flex;
    justify-content: flex-end;
  }
  .upgrade p {
    color: #ed1c24;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .subscribe-sub-1 {
    border: 0.7px solid #bac0d499;
    border-radius: 12px;
    width: 485px;
  }
  .payment-sub-2 p {
    color: #818893;
    font-size: 14px;
    font-weight: 400;
  }
  .payment-sub-2 {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .edit-btn {
    border: 0.7px solid #bac0d499;
    background: #ffffff;
    width: 61px;
    height: 40px;
    display: flex;
    text-decoration: none;
    color: #060b13;
    font-size: 14px;
    font-weight: 600;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
  }
  .visa-divs {
    display: flex;
    gap: 15px;
  }
  .visa-divs img {
    width: 58px;
    height: 40px;
  }
  .subscribe-1 h4 {
    color: #060b13;
    font-weight: 600;
    font-size: 18px;
  }
  .subscribe-1 p {
    color: #818893;
    font-size: 14px;
    font-weight: 400;
    margin-top: 10px;
  }
  .subscribe-2 {
    border: 0.7px solid #bac0d499;
    border-radius: 8px;
    padding: 15px;
    display: flex;
    justify-content: space-between;
  }
  .prem-p {
    max-width: 367px;
    color: #818893;
    font-size: 14px;
    font-weight: 400;
  }
  .subscribe-sub-2 {
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .upper-subscribe {
    display: flex;
    gap: 20px;
  }
  .download-btn {
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    color: #060b13;
    border: 0.7px solid #bac0d499;
    width: 154px;
    height: 40px;
    border-radius: 8px;
  }
  .bill h4 {
    color: #060b13;
    font-size: 16px;
    font-weight: 600;
  }
  .bill p {
    color: #818893;
    font-size: 14px;
    font-weight: 400;
    margin-top: 5px;
  }
  .all-bill {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  table {
    border: none;
    border-radius: 8px;
  }
  th {
    border: none;
  }
  td {
    border: none;
    border-top: 1px solid #bac0d499;
  }
  td {
    font-size: 14px;
    font-weight: 500;
    padding: 15px 0px;
  }
  th {
    background: #f9fafb;
    height: 44px;
    text-align: start;
    padding-left: 10px;
    color: #475467;
    font-size: 12px;
    font-weight: 500;
  }
  .username-pic {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .down-subscribe {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    gap: 20px;
  }
  .bill-table {
    border: 0.7px solid #BAC0D499;
    border-radius: 12px;
    padding: 24px;
  }

  .new-table-scroll {
width: 100% !important;
overflow-x: auto;

}

/* For WebKit Browsers (Chrome, Edge, Safari) */
.new-table-scroll::-webkit-scrollbar {
  height: 3px; /* Set scrollbar width */
 
}

.new-table-scroll::-webkit-scrollbar-thumb {
  background: #888; /* Scrollbar thumb color */
  border-radius: 4px; /* Optional for rounded scrollbar */
}

.new-table-scroll::-webkit-scrollbar-thumb:hover {
  background: #555; /* Thumb hover color */
}

.new-table-scroll::-webkit-scrollbar-track {
  background: #f1f1f1; /* Scrollbar track color */
}

/* Hide Up and Down Arrows in Scrollbar */
.new-table-scroll::-webkit-scrollbar-button {
  display: none; /* Hides the arrows */
}
.table-div-con {
  min-width: 800px;
 
 
}

  .upload-img-div {
    display: inline-block;
    padding: 8px 16px;
    background: #e8e9eb;

    color: #060b13 !important;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
  }
  .fileInput {
    display: none;
  }
  .tap-to-upload h6 {
    font-size: 14px;
    color: #171717;
    font-weight: 500;
  }
  .file-upload {
    width: 201px;
    height: 83px;

    justify-content: center;
    display: flex;
    gap: 16px;
    border-radius: 15px;
    align-items: center;
    border: 0.8px solid #bac0d4b2;
  }
  .tap-to-upload p {
    font-size: 12px;
    color: #9499ac;
    font-family: "Inter";
  }
  .uploadedImage {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .uploadedImage p {
    font-weight: 400;
    max-width: 201px;
    font-size: 12px;
    color: #828286;
  }
  .uploadedImage-default {
    max-width: 201px;
    height: 83px;
    border-radius: 5px;
  }
  .add-uploaded-divs {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  @media (max-width: 992px) {
.user-info-2, .user-info-btn {
  flex-wrap: wrap;
}
.all-account  {
  margin-right: 10px !important;
  padding: 10px !important;
}
.setting-div-2 {
  padding: 10px !important;

}
  }
  @media (max-width: 768px) {
.upper-subscribe {
  flex-wrap: wrap;
}
.subscribe-sub-1 {
  width: 100%;
}
  }
  @media (max-width: 475px) {
    .password-div, .password-div input, .monthly-sub {
      width: 300px;
}
  }
  @media (max-width: 450px) {
.user-info-2 p{
  width: 300px !important;
}
.profile-link {
  width: 80px;
}
.add-uploaded-divs {
  flex-wrap: wrap;
}
.all-plan-premium {
  flex-wrap: wrap;
}
  }
  @media (max-width: 380px) {
    .password-div, .password-div input, .monthly-sub, .user-info-2 p {
      width: 250px !important;
}
.visa-divs {
  flex-wrap: wrap;
}
  }
`;

const Setting = () => {
    const dispatch = useDispatch();
     const { userData, userImage, userimageUrl, imageloading, eventSuccessTwo, loading, error } =
        useSelector((state) => state.userData);
  
  const billing = [
    {
      id: 1,
      invoice: "Invoice #007 – Dec 2022",
      date: "Dec 1, 2022",
      status: "Paid",
      amount: "$10.00",
      plan: "Premium",
    },
    {
      id: 2,
      invoice: "Invoice #006 – Nov 2022",
      date: "Nov 1, 2022",
      status: "Pending",
      amount: "$10.00",
      plan: "Premium",
    },
    {
      id: 3,
      invoice: "Invoice #006 – Oct 2022",
      date: "Oct 1, 2022",
      status: "Paid",
      amount: "$10.00",
      plan: "Premium",
    },
    {
      id: 4,
      invoice: "Invoice #004 – Sep 2022",
      date: "Sep 1, 2022",
      status: "Pending",
      amount: "$10.00",
      plan: "Premium",
    },
    {
      id: 5,
      invoice: "Invoice #001 – Jun 2022",
      date: "Jun 1, 2022",
      status: "Paid",
      amount: "$10.00",
      plan: "Basic",
    },
  ];
  const [activeLink, setActiveLink] = useState("account");
  const [profileLink, setProfileLink] = useState("profile");
  const [channelLink, setChannelLink] = useState("profile");
  const [selectedOption, setSelectedOption] = useState("default");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [linkdropdown, setLinkdropdown] = useState(false);
const [imageDisplay, setImageDisplay] = useState(null)

  const userInfo = userData?.data

console.log(imageDisplay);

useEffect(() => {
  if (userImage) {
    if (userImage instanceof File || userImage instanceof Blob) {
      // handle file upload preview
      setImageDisplay(URL.createObjectURL(userImage));
    } else if (typeof userImage === "string") {
      // backend gave you base64
      setImageDisplay(`data:image/png;base64,${userImage}`);
    }
  }
}, [userImage]);

  
  const images = userData?.data?.userImageDetails || []
const lastImage = images?.slice(-1)[0];


  const handleLinkDropdown = () => {
    setLinkdropdown(!linkdropdown);
  };

  const handleChannelLink = (link) => {
    setChannelLink(link);
  };
  const handleProfileLink = (links) => {
    setProfileLink(links);
  };
  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

   useEffect(() => {
      dispatch(fetchUsers());
    }, [dispatch]);

       useEffect(() => {
      dispatch(fetchUsersImage());
    }, [dispatch]);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setUploadedImage(e.target.result); // Set the uploaded image
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageUploadTwo = (event) => {
  const file = event.target.files[0];
  if (file) {
    dispatch(uploadUsersImage(file)); // keep file for upload
  }
};


  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };
  return (
    <SettingRap>
      <div className="setting-div-1">
        <h4>Settings</h4>
        <p>Analyze the number of plays and more</p>
      </div>
      <div className="setting-div-2">
        <div className="link-container">
          <Link
            className={`link ${activeLink === "account" ? "active" : ""}`}
            onClick={() => handleLinkClick("account")}
          >
            Account
          </Link>
          <Link
            className={`link ${activeLink === "channel" ? "active" : ""}`}
            onClick={() => handleLinkClick("channel")}
          >
            Channel
          </Link>
          <Link
            className={`link ${activeLink === "subscription" ? "active" : ""}`}
            onClick={() => handleLinkClick("subscription")}
          >
            Subscription
          </Link>
        </div>
        <div>
          {activeLink === "account" && (
            <>
              <div className="profile-link-contain">
                <Link
                  className={`profile-link ${
                    profileLink === "profile" ? "active" : ""
                  }`}
                  onClick={() => handleProfileLink("profile")}
                >
                  Profile
                </Link>
                <Link
                  className={`profile-link ${
                    profileLink === "password" ? "active" : ""
                  }`}
                  onClick={() => handleProfileLink("password")}
                >
                  Password
                </Link>
                <Link
                  className={`profile-link ${
                    profileLink === "notification" ? "active" : ""
                  }`}
                  onClick={() => handleProfileLink("notification")}
                >
                  Notification
                </Link>
              </div>
              <div className="all-account">
                {profileLink === "profile" && (
                  <>
                    <div className="profile">
                      <div className="user-info-1">
                        
      <img
        src={userImage}
        alt=""
      />
    
                       <div className="uploadedImage">
                          <div className="file-upload">
                            <label className="upload-img-div">
                              
                              {imageloading ? (
                                                 <ClipLoader color="white" size={40} />
                                               ) : (
                                                 "Choose Image"
                                               )}
                              <input
                                onChange={handleImageUploadTwo}
                                type="file"
                                accept="image/*"
                                className="fileInput"
                              />
                            </label>
                          </div>
                          <p>
                            JPG or PNG accepted, Max size 10mb. (Default size:
                            1400x800)
                          </p>
                        </div>
                      </div>
                      <div className="user-info-2">
                        <p>{userInfo?.lname} {userInfo?.fname}</p>
                        <p>{userInfo?.email}</p>
                      </div>
                      <div className="user-info-2">
                        <p
                          style={{
                            justifyContent: "space-between",
                          }}
                        >
                          (GMT +01:00) West Central Africa
                        </p>
                        <p
                          style={{
                            height: "120px",
                            borderRadius: "15px",
                            alignItems: "flex-start",
                          }}
                        >
                          Network conference, where industry leaders will
                          discuss the latest trends and innovations shaping the
                          future of technology.{" "}
                        </p>
                      </div>
                      <div className="user-info-btn">
                        <button style={{ background: "#ffffff" }}>
                          Cancel
                        </button>
                        <button
                          style={{ background: "#ED1C24", color: "#ffffff" }}
                        >
                          Save changes
                        </button>
                      </div>
                    </div>
                  </>
                )}
                {profileLink === "password" && (
                  <div className="all-password">
                    <div className="password-div">
                      <Icon
                        className="pass-lock"
                        icon="solar:lock-keyhole-outline"
                        width="18"
                        height="18"
                        style={{ color: "#99A2AF", cursor: "pointer" }}
                      />
                      <input type="text" placeholder="Current password" />
                      <Icon
                        className="pass-eye"
                        icon="iconamoon:eye-off-light"
                        width="18"
                        height="18"
                        style={{ color: "#99A2AF", cursor: "pointer" }}
                      />
                    </div>
                    <div className="password-div">
                      <Icon
                        className="pass-lock"
                        icon="solar:lock-keyhole-outline"
                        width="18"
                        height="18"
                        style={{ color: "#99A2AF", cursor: "pointer" }}
                      />
                      <input type="text" placeholder="New password" />
                      <Icon
                        className="pass-eye"
                        icon="iconamoon:eye-off-light"
                        width="18"
                        height="18"
                        style={{ color: "#99A2AF", cursor: "pointer" }}
                      />
                    </div>
                    <div className="password-div">
                      <Icon
                        className="pass-lock"
                        icon="solar:lock-keyhole-outline"
                        width="18"
                        height="18"
                        style={{ color: "#99A2AF", cursor: "pointer" }}
                      />
                      <input type="text" placeholder="Confirm password" />
                      <Icon
                        className="pass-eye"
                        icon="iconamoon:eye-off-light"
                        width="18"
                        height="18"
                        style={{ color: "#99A2AF", cursor: "pointer" }}
                      />
                    </div>
                    <div className="user-info-btn">
                      <button style={{ background: "#ffffff" }}>Cancel</button>
                      <button
                        style={{ background: "#ED1C24", color: "#ffffff" }}
                      >
                        Save changes
                      </button>
                    </div>
                  </div>
                )}
                {profileLink === "notification" && (
                  <div className="notifications">
                    <div className="sub-notify">
                      <label>
                        <input type="checkbox" />
                        Listener follow
                      </label>
                      <p>Notify me when a listener follows me</p>
                    </div>
                    <div className="sub-notify">
                      <label>
                        <input type="checkbox" />
                        Schedule beginning
                      </label>
                      <p>Notify me when an events is due to begin</p>
                    </div>
                    <div className="sub-notify">
                      <label>
                        <input type="checkbox" />
                        Live broadcast
                      </label>
                      <p className="notice">
                        Notify me when a creator I follow start an event
                      </p>
                    </div>
                    <div className="monthly-sub">
                      <p>Monthly</p>
                      <Icon
                        icon="iconamoon:arrow-down-2-light"
                        width="18"
                        height="18"
                        style={{ color: "#99A2AF", cursor: "pointer" }}
                      />
                    </div>
                    <div className="down-notice">
                      <img src="/images/error.png" alt="" />
                      <p>Set your preference for broadcaster stats</p>
                    </div>
                    <div className="user-info-btn">
                      <button style={{ background: "#ffffff" }}>Cancel</button>
                      <button
                        style={{ background: "#ED1C24", color: "#ffffff" }}
                      >
                        Save changes
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
          {activeLink === "channel" && (
            <>
              <div className="profile-link-contain">
                <Link
                  className={`profile-link ${
                    channelLink === "profile" ? "active" : ""
                  }`}
                  onClick={() => handleChannelLink("profile")}
                >
                  Profile
                </Link>
                <Link
                  className={`profile-link ${
                    channelLink === "links" ? "active" : ""
                  }`}
                  onClick={() => handleChannelLink("links")}
                >
                  Links
                </Link>
                <Link
                  className={`profile-link ${
                    channelLink === "setting" ? "active" : ""
                  }`}
                  onClick={() => handleChannelLink("setting")}
                >
                  Settings
                </Link>
              </div>
              <div className="all-account">
                {channelLink === "profile" && (
                  <>
                    <div className="profile channel">
                      <div className="user-info-1 channel-1">
                        <img src="/images/image_9.png" alt="" />
                        <p>
                          JPG or PNG accepted, Max size 10mb. (Default size:
                          1400x800)
                        </p>
                      </div>
                      <div className="user-info-2">
                        <p>Network conference channel</p>
                        <p>
                          https://
                          <span
                            style={{
                              color: "#ED1C24",
                            }}
                          >
                            rccglag56
                          </span>
                          .mixlr.com
                        </p>
                      </div>
                      <div className="user-info-2">
                        <div className="add-uploaded-divs">
                          <div>
                            <label className="custom-radio">
                              <input
                                type="radio"
                                value="default"
                                checked={selectedOption === "default"}
                                onChange={handleRadioChange}
                              />
                              <span className="radio-checkmark"></span>
                              Use default theme
                            </label>

                            <label className="custom-radio">
                              <input
                                type="radio"
                                value="upload"
                                checked={selectedOption === "upload"}
                                onChange={handleRadioChange}
                              />
                              <span className="radio-checkmark"></span>
                              Upload image
                            </label>
                          </div>

                          {selectedOption === "default" && (
                            <div>
                              <img
                                className="uploadedImage-default"
                                src="/images/image_1.png" // Replace with your default image URL
                                alt="Default Theme"
                                style={{
                                  width: "300px",
                                  height: "150px",
                                  border: "1px solid #ccc",
                                }}
                              />
                            </div>
                          )}

                          {selectedOption === "upload" && (
                            <div>
                              {!uploadedImage ? (
                                <div className="uploadedImage">
                                  <div className="file-upload">
                                    <label className="upload-img-div">
                                      Choose Image
                                      <input
                                        onChange={handleImageUpload}
                                        type="file"
                                        accept="image/*"
                                        className="fileInput"
                                      />
                                    </label>
                                  </div>
                                  <p>
                                    JPG or PNG accepted, Max size 10mb. (Default
                                    size: 1400x800)
                                  </p>
                                </div>
                              ) : (
                                <img
                                  className="uploadedImage-default"
                                  src={uploadedImage}
                                  alt="Uploaded"
                                  style={{
                                    width: "300px",
                                    height: "150px",
                                    border: "1px solid #ccc",
                                  }}
                                />
                              )}
                            </div>
                          )}
                        </div>
                        <p
                          style={{
                            height: "120px",
                            borderRadius: "15px",
                            alignItems: "flex-start",
                          }}
                        >
                          Network conference, where industry leaders will
                          discuss the latest trends and innovations shaping the
                          future of technology.{" "}
                        </p>
                      </div>

                      <div className="down-notice">
                        <img src="/images/error.png" alt="" />
                        <p>Set your preference background color</p>
                      </div>

                      <div className="user-info-btn channel-1">
                        <button style={{ background: "#ffffff" }}>
                          Cancel
                        </button>
                        <button
                          style={{ background: "#ED1C24", color: "#ffffff" }}
                        >
                          Save changes
                        </button>
                      </div>
                    </div>
                  </>
                )}
                {channelLink === "links" && (
                  <>
                    <div className="profile channel">
                      <div className="user-info-2">
                        <div style={{ position: "relative" }}>
                          <div
                            onClick={handleLinkDropdown}
                            className="monthly-sub"
                          >
                            <p
                              style={{
                                border: "none",
                                color: "#99A2AF",
                              }}
                            >
                              https://
                            </p>
                            <Icon
                              icon="iconamoon:arrow-down-2-light"
                              width="18"
                              height="18"
                              style={{ color: "#99A2AF", cursor: "pointer" }}
                            />
                          </div>
                          {linkdropdown ? (
                            <div className="linkdropdown">
                              <h6>Website</h6>
                              <h6>Tumblr</h6>
                              <h6>Blog</h6>
                              <h6>Facebook</h6>
                              <h6>Twitter</h6>
                              <h6>Myspace</h6>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="monthly-sub">
                          <p
                            style={{
                              border: "none",
                              color: "#99A2AF",
                            }}
                          >
                            https://
                          </p>
                          <Icon
                            icon="iconamoon:arrow-down-2-light"
                            width="18"
                            height="18"
                            style={{ color: "#99A2AF", cursor: "pointer" }}
                          />
                        </div>
                      </div>
                      <div className="down-notice">
                        <img src="/images/error.png" alt="" />
                        <p
                          style={{
                            maxWidth: "355px",
                            lineHeight: "17px",
                          }}
                        >
                          Got a payment service link? Include the full URL (e.g
                          https://www.paypal.me/username)
                        </p>
                      </div>
                      <div className="monthly-sub">
                        <p
                          style={{
                            border: "none",
                            color: "#99A2AF",
                          }}
                        >
                          https://
                        </p>
                        <Icon
                          icon="iconamoon:arrow-down-2-light"
                          width="18"
                          height="18"
                          style={{ color: "#99A2AF", cursor: "pointer" }}
                        />
                      </div>
                      <div className="user-info-btn channel-1">
                        <button style={{ background: "#ffffff" }}>
                          Cancel
                        </button>
                        <button
                          style={{ background: "#ED1C24", color: "#ffffff" }}
                        >
                          Save changes
                        </button>
                      </div>
                    </div>
                  </>
                )}
                {channelLink === "setting" && (
                  <div className="notifications">
                    <div className="sub-notify">
                      <label>
                        <input type="checkbox" />
                        Chat
                      </label>
                      <p>Users will be able to chat</p>
                    </div>
                    <div className="sub-notify">
                      <label>
                        <input type="checkbox" />
                        Chat options (GIFs)
                      </label>
                      <p>Users will be able to chat with GIFs</p>
                    </div>
                    <div className="sub-notify">
                      <label>
                        <input type="checkbox" />
                        Listener follow
                      </label>
                      <p className="notice">
                        Notify me when a listener follows me
                      </p>
                    </div>
                    <div className="sub-notify">
                      <label>
                        <input type="checkbox" />
                        Schedule beginning
                      </label>
                      <p className="notice">
                        Notify my users when an events is due to begin
                      </p>
                    </div>
                    <div className="sub-notify">
                      <label>
                        <input type="checkbox" />
                        Live broadcast
                      </label>
                      <p className="notice">
                        Notify my users when I’m going live
                      </p>
                    </div>
                    <div className="monthly-sub">
                      <p>Monthly</p>
                      <Icon
                        icon="iconamoon:arrow-down-2-light"
                        width="18"
                        height="18"
                        style={{ color: "#99A2AF", cursor: "pointer" }}
                      />
                    </div>
                    <div className="down-notice">
                      <img src="/images/error.png" alt="" />
                      <p>Set your preference for broadcaster stats</p>
                    </div>
                    <div className="user-info-btn">
                      <button style={{ background: "#ffffff" }}>Cancel</button>
                      <button
                        style={{ background: "#ED1C24", color: "#ffffff" }}
                      >
                        Save changes
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
          {activeLink === "subscription" && (
            <>
              <div className="upper-subscribe">
                <div className="subscribe-sub-1">
                  <div className="all-plan-premium">
                    <div className="premium-plan">
                      <div className="premium">
                        <h4>Premium plan</h4>
                        <h5>Monthly</h5>
                      </div>
                      <p>Our most popular plan for small teams.</p>
                    </div>
                    <div className="per-month">
                      <h3>$10</h3>
                      <p>per month</p>
                    </div>
                  </div>
                  <div className="dated-divs">
                    <div className="dated">
                      <Icon
                        icon="stash:calendar-light"
                        width="16"
                        height="16"
                        style={{ color: "#818893", cursor: "pointer" }}
                      />
                      <p>Start date: 08 Jul,2023</p>
                    </div>
                    <div className="dated">
                      <Icon
                        icon="stash:calendar-light"
                        width="16"
                        height="16"
                        style={{ color: "#818893", cursor: "pointer" }}
                      />
                      <p>End date: 08 Jul,2023</p>
                    </div>
                  </div>
                  <div className="upgrade">
                    <p>Upgrade plan</p>
                    <Icon
                      icon="solar:arrow-right-up-outline"
                      width="16"
                      height="16"
                      style={{ color: "#ED1C24", cursor: "pointer" }}
                    />
                  </div>
                </div>
                <div className="subscribe-sub-1 subscribe-sub-2">
                  <div className="subscribe-1">
                    <h4>Payment method</h4>
                    <p>Change how you pay for your plan.</p>
                  </div>
                  <div className="subscribe-2">
                    <div className="visa-divs">
                      <img src="/images/visa_img.png" alt="" />
                      <div className="payment-sub-2">
                        <p>Visa ending in 1234</p>
                        <p>Expiry 06/2024</p>
                        <p>billing@plugrl.com</p>
                      </div>
                    </div>
                    <Link className="edit-btn">Edit</Link>
                  </div>
                  <p className="prem-p">
                    Your plugrl premium plan will be automatically renew 09
                    Apr,2024.{" "}
                  </p>
                </div>
              </div>
              <div className="down-subscribe">
                <div className="all-bill">
                  <div className="bill">
                    <h4>Billing and invoicing</h4>
                    <p>Pick an account plan that fits your workflow.</p>
                  </div>
                  <Link className="download-btn">Download all</Link>
                </div>
                <div className="bill-table">
                <div className="new-table-scroll">
                <div className="table-div-con">
                  <table
                    border="1"
                    cellPadding="10"
                    cellSpacing="0"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>Invoice</th>
                        <th>Billing date</th>
                        <th>Status</th>
                        <th>Amount</th>
                        <th>Plan</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {billing.map((user) => (
                        <tr key={user.id}>
                          <td
                            style={{
                              color: "#060B13",
                            }}
                          >
                            <div className="username-pic">
                              <img src="/images/fea-icon.png" alt="" />
                              {user.invoice}
                            </div>
                          </td>
                          <td>{user.date}</td>
                          <td
                           
                          >
                            <div  style={{
                              background:
                                user.status === "Paid"
                                  ? "#ECFDF3"
                                  : user.status === "Pending"
                                  ? "#FFFAEB"
                                  : "#FEF3F2",
                            color:
                                  user.status === "Paid"
                                    ? "#027A48"
                                    : user.status === "Pending"
                                    ? "#B54708"
                                    : "#B42318",
                                padding: "2px 8px",
                                borderRadius: "16px",
                                width: "fit-content"
                              
                            }}>
                            {user.status}
                            </div>
                          </td>
                          <td>{user.amount}</td>
                          <td>{user.plan}</td>
                          <td>
                            <Link style={{
                                color: "#818893"
                            }}>Download</Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {userimageUrl ? (
          <div className="dropdown-container">
            <div className="all-dropdown-div">
             
              <div className="dropdown-div">
                <p style={{
                  margin: "auto",
                  fontSize: "20px",
                  maxWidth: "300px",
                  fontWeight: "600",
                  paddingBottom: "30px"
                }}>{userimageUrl?.message}</p>
                <button onClick={()=> dispatch(resetUserImageUpload())} className="schedule-btn">CLOSE</button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
    </SettingRap>
  );
};

export default Setting;
